const getFormatedFloat = (value, digitAfterDecimal = 2) => {
  return new Intl.NumberFormat("en-US").format(
    parseFloat(value).toFixed(digitAfterDecimal),
  );
};

export default getFormatedFloat;
